import elDataHelper from '@/scripts/helpers/element-data-helper';
import checkRules from './rules';
import DATA_NAMESPACE from './namespace';
import Page from './Page';

const getModuleWrapper = (pageModule) => {
  if (pageModule == null) return { default: pageModule };
  if (pageModule.default) return pageModule;
  return { default: pageModule };
};

const pageLoader = {
  load(modulesMap) {
    const pagesElements = elDataHelper.selectAll('data-' + DATA_NAMESPACE.page);
    const pages = pagesElements.forEach((element) => {
      const page = new Page(element);

      // Initialise page module if exist
      const moduleWrapper = getModuleWrapper(modulesMap[page.moduleName]);
      moduleWrapper.default()
        .then((pageModule) => {
          const pageRules = Object.keys(moduleWrapper.rules || {});
          page.setModule(pageModule);
          checkRules(pageRules)
            .then(() => page.init())
            .catch((error) => {
              if (error.message === 'No module is set for this page yet.') {
                // TODO: Use a centralized error logger
                // eslint-disable-next-line no-console
                console.warn(`The page "${page.name}" does not has a matching module ("${page.moduleName}").`);
              } else {
                throw error;
              }
            });
        });
    });

    return pages;
  },
};

export default pageLoader;
